<div class="skeleton-loader-container">
  <!-- Horizontal rectangles -->
  <div
    *ngIf="shape?.horizontalRectangle?.display"
    class="skeleton-loader-container__vertical-rectangle"
    [style]="gridStyle(shape.horizontalRectangle?.count)"
  >
    <div *ngFor="let item of countArray(shape.horizontalRectangle?.count)">
      <div
        class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-large"
      ></div>
    </div>
  </div>
  <!-- Vertical rectangles -->
  <div
    *ngIf="shape?.verticalRectangle?.display"
    class="skeleton-loader-container__vertical-rectangle"
    [style]="gridStyle(shape.verticalRectangle?.count)"
  >
    <div *ngFor="let item of countArray(shape.verticalRectangle?.count)">
      <div
        class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-large"
      ></div>
      <div
        class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-small"
      ></div>
      <div
        class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-small"
      ></div>
    </div>
  </div>
  <!-- Mixed shapes -->
  <div *ngIf="shape?.mixed?.display" class="skeleton-loader-container__mixed">
    <div
      class="skeleton-loader-container__shimmer skeleton-loader-container__circle"
    ></div>
    <div
      class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-large"
    ></div>
    <div
      class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-medium"
    ></div>
    <div
      class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-small"
    ></div>
    <div
      class="skeleton-loader-container__shimmer skeleton-loader-container__rectangle-very-small skeleton-loader-container__button"
    ></div>
  </div>
</div>
